import FuseAnimate from '@fuse/core/FuseAnimate';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import React, { useEffect, useState } from 'react';
import { submitEncompassToken } from 'app/auth/store/loginSlice';
import { takeEncompassReturnTo } from 'app/main/utils/encompass';
import { useDispatch } from 'react-redux';

function EncompassLogin() {
  const dispatch = useDispatch();
  const [error, setError] = useState('');

  useEffect(() => {
    const authorizationCode = new URLSearchParams(window.location.search).get('code');
    const redirectUri = process.env.REACT_APP_REDIRECT_URL;

    // The code is single-use, so it is exchanged exactly once.
    dispatch(submitEncompassToken({ authorizationCode, redirectUri })).catch(cause =>
      setError(cause?.message || 'Encompass rejected the sign-in. Please try again.')
    );
  }, [dispatch]);

  return (
    <div className="flex flex-col flex-1 items-center justify-center p-16">
      <div className="max-w-512 text-center">
        <FuseAnimate animation="transition.expandIn" delay={100}>
          <Typography variant="h1" color="inherit" className="font-medium mb-16">
            {error ? 'Encompass' : 'Connecting…'}
          </Typography>
        </FuseAnimate>

        <FuseAnimate delay={500}>
          <Typography variant="h5" color="textSecondary" className="mb-16">
            {error || 'Signing in with Encompass. You will be redirected soon...'}
          </Typography>
        </FuseAnimate>

        {error && (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              window.location.href = takeEncompassReturnTo();
            }}
          >
            Go back
          </Button>
        )}
      </div>
    </div>
  );
}

export default EncompassLogin;
